<!--
からだスタンプ
fileName : static配下の格納したファイル名を渡す
index: オブジェクトのキーを取得する
-->
<template>
  <div @click="toggleStamp" class="stamp">
    <img
      :src="loadImg"
      :alt="index"
      class="stamp__icon"
      :data-test="`stamp__icon--${index}`"
    />
    <div class="stamp__label" v-text="label" />
  </div>
</template>

<script>
import VueTypes from "vue-types";

export default {
  props: {
    fileName: VueTypes.string.isRequired,
    index: VueTypes.string.isRequired,
    label: VueTypes.string.isRequired
  },
  computed: {
    loadImg() {
      return require(`../../../../static/svg/${this.fileName}`);
    }
  },
  methods: {
    toggleStamp() {
      this.$emit("toggleStamp", this.index);
    }
  }
};
</script>

<style scoped>
.stamp:hover {
  cursor: pointer;
}
.stamp__icon {
  width: 2rem;
  margin-top: 10px;
}
.stamp__label {
  margin-top: 10px;
}
</style>
